module.exports = __webpack_public_path__ + "static/media/availableLocationMarker.695060e1.svg";